// extracted by mini-css-extract-plugin
export default {"illustrationError":"NetworkErrorBoundary_illustrationError__0KdKi"};